import { Injector, NgModule, APP_INITIALIZER } from "@angular/core";
import { AppComponent } from "./app.component";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { TableSortService } from "./services/table-sort.service";
import { RolesPrivilegesModule } from "./admin/roles-privileges/roles-privileges.module";
import { MenuModule } from "./menu/menu.module";
import { CustomErrorComponent } from "./shared/error-page/custom-error-page.component";
import { environment } from "../environments/environment";
import { CalAngularModule } from "@cvx/cal-angular";
import { AppRoutingModule } from "./app-routing.module";
import { TokenInterceptor } from "./interceptors/token-interceptor";
import { PagesModule } from "./pages.module";
import { ConfigService } from "./services/common/config.service";
import { ChatModule } from "./chat/chat.module";

/**
 * Factory function to load application configuration before app initialization
 */
export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig().toPromise();
}

const componentList = [
  AppComponent,
  CustomErrorComponent,
];

@NgModule({
  declarations: [],
  imports: [
    ...componentList,
    HttpClientModule,
    RolesPrivilegesModule,
    MenuModule,
    PagesModule,
    ChatModule,
    AppRoutingModule,
    CalAngularModule.forRoot({
      autoSignIn: true,
      popupForLogin: false,
      cacheLocation: "localStorage",
      instance: "https://login.microsoftonline.com/",
      tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
      clientId: environment.clientId,
      redirectUri: "/auth",
      oidcScopes: ["openid", "profile", "User.Read", "offline_access"],
      graphScopes: ["User.Read", "User.Read.All", "Group.Read.All"],
    }),
  ],
  exports: [],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    TableSortService,
  ],
})
export class AppTest {
  constructor(private injector: Injector) {}
}